import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '中国·武陵山首届山茶花杯武陵创意之星青年设计师大赛';
const baseUrl = '20221024SCHB';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/news`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeDetail',
      name: `${baseUrl}-homeDetail`,
      component: () => import('./pages/HomeDetail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'link',
      name: `${baseUrl}-link`,
      component: () => import('./pages/Link.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
